import { Root } from './styled-components';
export const Image = Root;
